import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { bankAccountsApi } from 'src/Services/API';

const useFetchBankAccount = (bankAccountId?: string) => {
  const assetId = useCurrentAssetId();
  return useQuery({
    queryKey: ['fetch-bank-account', bankAccountId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      if (!bankAccountId) throw new Error('No bankAccountId provided');

      return (await bankAccountsApi.bankAccountsControllerFindOne(bankAccountId, assetId)).data;
    },
    enabled: !!assetId && !!bankAccountId,
  });
};

export default useFetchBankAccount;
